export type AttachmentPreviewKind = "pdf" | "spreadsheet" | "text" | "archive" | "unknown";

export interface AttachmentPreview {
  kind: AttachmentPreviewKind;
  title: string;
  metadata: ReadonlyArray<readonly [string, string]>;
  lines: readonly string[];
  warning?: string;
}

const previewCatalog: Record<string, AttachmentPreview> = {
  "備品申請書_0722.xlsx": {
    kind: "spreadsheet",
    title: "備品申請書（2026年7月22日）",
    metadata: [
      ["申請部署", "情報管理部"],
      ["申請者", "高橋 真紀"],
      ["状態", "受付済み"]
    ],
    lines: [
      "単3形乾電池｜12本｜夜間監視端末用",
      "付箋 75×25mm｜3冊｜引き継ぎ記録用",
      "希望納期｜2026/07/24"
    ]
  },
  "INC-2741_復旧報告.txt": {
    kind: "text",
    title: "INC-2741 復旧報告",
    metadata: [
      ["管理番号", "INC-2741"],
      ["担当", "情報管理部 木村"],
      ["状態", "復旧済み"]
    ],
    lines: [
      "00:08　社内メール配送キューの遅延を検知",
      "00:12　滞留メッセージの再送処理を実施",
      "00:14　遅延解消。監視を通常状態へ移行"
    ]
  },
  "INC-274I_復旧報告.txt": {
    kind: "text",
    title: "INC-274I 復旧報告",
    metadata: [
      ["管理番号", "INC-274I"],
      ["担当", "情報管理部 木村"],
      ["状態", "復旧済み"]
    ],
    lines: [
      "00:08　社内メール配送キューの遅延を検知",
      "00:12　滞留メッセージの再送処理を実施",
      "00:14　遅延解消。監視を通常状態へ移行"
    ],
    warning: "本文に記載された管理番号と一致しているか確認してください。"
  },
  "交通費申請手順.pdf": {
    kind: "pdf",
    title: "夜間交通費 申請手順",
    metadata: [
      ["発行", "総務部"],
      ["版", "第3版"],
      ["更新日", "2026/06/01"]
    ],
    lines: [
      "1. 夜間勤務に伴う交通費の上限は1勤務につき4,000円です。",
      "2. 利用日・金額・利用目的を申請フォームへ入力してください。",
      "3. 領収書の原本を翌営業日までに総務部へ提出してください。"
    ]
  },
  "mail_archive_0723.zip": {
    kind: "archive",
    title: "mail_archive_0723.zip",
    metadata: [
      ["形式", "ZIPアーカイブ"],
      ["作成元", "夜間監視システム"],
      ["暗号化", "社内端末のみ展開可"]
    ],
    lines: [
      "20260722_2340_system.eml",
      "20260722_2348_equipment.eml",
      "20260722_2352_handover.eml",
      "manifest.sha256"
    ]
  },
  "空調清掃範囲.pdf": {
    kind: "pdf",
    title: "2階東側 空調清掃範囲",
    metadata: [
      ["作業日時", "2026/07/24 13:00–15:00"],
      ["担当", "施設管理"],
      ["代替室", "第三会議室"]
    ],
    lines: [
      "対象：2階東側執務区画・廊下・休憩室",
      "対象外：情報管理部サーバー室",
      "作業中は第三会議室を一時執務場所として利用してください。"
    ]
  },
  "夜間監視_引き継ぎ表.xlsx": {
    kind: "spreadsheet",
    title: "夜間監視 引き継ぎ表",
    metadata: [
      ["対象日", "2026/07/23"],
      ["担当", "夜間監視担当"],
      ["提出先", "情報管理部"]
    ],
    lines: [
      "未処理メール件数｜記入待ち",
      "異常報告件数｜記入待ち",
      "監視端末状態｜正常",
      "備考｜午前6時に端末をロック"
    ]
  },
  "旧管理部_引継一覧.xlsx": {
    kind: "spreadsheet",
    title: "旧管理部 引継一覧",
    metadata: [
      ["最終更新", "2024/11/08"],
      ["更新者", "山田 修司"],
      ["状態", "参照専用"]
    ],
    lines: [
      "月次報告書｜管理部共有｜移管済み",
      "設備台帳｜総務部共有｜移管済み",
      "夜間監視記録｜保存先不明｜要確認"
    ]
  },
  "管理部_月次報告.xlsx": {
    kind: "spreadsheet",
    title: "管理部 月次報告",
    metadata: [
      ["対象月", "2024年12月"],
      ["作成者", "山田 修司"],
      ["状態", "旧版"]
    ],
    lines: [
      "監視対象端末｜4台",
      "異常報告｜0件",
      "次月引継ぎ｜アカウント停止処理を実施"
    ]
  },
  "夜間監視担当_退職届.pdf": {
    kind: "pdf",
    title: "退職届",
    metadata: [
      ["氏名", "夜間監視担当"],
      ["所属", "情報管理部"],
      ["退職日", "2026/07/22"]
    ],
    lines: [
      "一身上の都合により、上記日付をもって退職いたします。",
      "アカウントおよび夜間監視端末の利用権限は停止済みです。",
      "提出先：総務部 人事担当"
    ],
    warning: "現在ログイン中の利用者情報と照合してください。"
  },
  "退職者一覧_最新版.xlsx": {
    kind: "spreadsheet",
    title: "退職者一覧（最新版）",
    metadata: [
      ["管理部署", "総務部"],
      ["更新日時", "2026/07/23 05:58"],
      ["取扱区分", "社内限定"]
    ],
    lines: [
      "山田 修司｜管理部｜2024/12/27｜アカウント停止済み",
      "夜間監視担当｜情報管理部｜2026/07/22｜アカウント停止済み"
    ],
    warning: "一覧に現在の利用者が含まれていないか確認してください。"
  }
};

function inferKind(fileName: string): AttachmentPreviewKind {
  const extension = fileName.split(".").pop()?.toLowerCase();
  if (extension === "pdf") return "pdf";
  if (extension === "xlsx" || extension === "xls" || extension === "csv") return "spreadsheet";
  if (extension === "txt" || extension === "log") return "text";
  if (extension === "zip" || extension === "7z") return "archive";
  return "unknown";
}

export function getAttachmentPreview(fileName: string): AttachmentPreview {
  const known = previewCatalog[fileName];
  if (known) return known;

  const extension = fileName.split(".").pop()?.toUpperCase() ?? "不明";
  return {
    kind: inferKind(fileName),
    title: fileName,
    metadata: [
      ["ファイル名", fileName],
      ["形式", extension],
      ["状態", "プレビュー情報なし"]
    ],
    lines: [
      "この添付ファイルには登録済みのプレビュー内容がありません。",
      "ファイル名、拡張子、メール本文との整合性を確認してください。"
    ]
  };
}
